import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "arrowPointAtCenter", "mouseEnterDelay", "mouseLeaveDelay", "placement", "trigger", "onVisibleChange", "content", "title", "visible", "overlayClassName", "autoAdjustOverflow"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import _noop from 'lodash/noop';
import { Consumer } from '../AntdPopupContainerContext';
import { computeGetPopupContainerProp } from '../../utils/popUpUtils';
import './tPopover.scss';

// Constants
import { POPOVER_TRIGGER, POPOVER_PLACEMENT } from './popover.constants';
var getVisibleProp = function getVisibleProp(visible, content) {
  if (visible !== undefined) return {
    visible: visible && content
  };
  if (!content) return {
    visible: false
  };
  return null;
};
var computePopoverExtraProps = function computePopoverExtraProps(_ref) {
  var visible = _ref.visible,
    scrollParentRef = _ref.scrollParentRef,
    scrollParentSelector = _ref.scrollParentSelector,
    content = _ref.content;
  return Object.assign({}, getVisibleProp(visible, content), computeGetPopupContainerProp({
    scrollParentRef: scrollParentRef,
    scrollParentSelector: scrollParentSelector
  }));
};
var TPopover = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TPopover, _React$PureComponent);
  var _super = _createSuper(TPopover);
  function TPopover() {
    _classCallCheck(this, TPopover);
    return _super.apply(this, arguments);
  }
  _createClass(TPopover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        arrowPointAtCenter = _this$props.arrowPointAtCenter,
        mouseEnterDelay = _this$props.mouseEnterDelay,
        mouseLeaveDelay = _this$props.mouseLeaveDelay,
        placement = _this$props.placement,
        trigger = _this$props.trigger,
        onVisibleChange = _this$props.onVisibleChange,
        content = _this$props.content,
        title = _this$props.title,
        visible = _this$props.visible,
        overlayClassName = _this$props.overlayClassName,
        autoAdjustOverflow = _this$props.autoAdjustOverflow,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      // Please ensure that the child node of popover accepts onMouseEnter, onMouseLeave, onFocus, onClick events.
      return /*#__PURE__*/React.createElement(Consumer, null, function (_ref2) {
        var scrollParentRef = _ref2.scrollParentRef,
          scrollParentSelector = _ref2.scrollParentSelector;
        var extraProps = Object.assign(restProps, computePopoverExtraProps({
          visible: visible,
          scrollParentSelector: scrollParentSelector,
          scrollParentRef: scrollParentRef,
          content: content
        }));
        return /*#__PURE__*/React.createElement(Popover, _extends({
          arrowPointAtCenter: arrowPointAtCenter,
          mouseEnterDelay: mouseEnterDelay,
          mouseLeaveDelay: mouseLeaveDelay,
          content: content,
          trigger: trigger,
          onVisibleChange: onVisibleChange,
          placement: placement,
          title: title,
          autoAdjustOverflow: autoAdjustOverflow
        }, extraProps, {
          overlayClassName: overlayClassName
        }), children);
      });
    }
  }]);
  return TPopover;
}(React.PureComponent);
_defineProperty(TPopover, "propTypes", {
  arrowPointAtCenter: PropTypes.bool,
  mouseEnterDelay: PropTypes.number,
  mouseLeaveDelay: PropTypes.number,
  // overlayClassName: PropTypes.string,
  placement: PropTypes.oneOf([POPOVER_PLACEMENT.TOP, POPOVER_PLACEMENT.LEFT, POPOVER_PLACEMENT.RIGHT, POPOVER_PLACEMENT.BOTTOM, POPOVER_PLACEMENT.TOP_LEFT, POPOVER_PLACEMENT.TOP_RIGHT, POPOVER_PLACEMENT.BOTTOM_LEFT, POPOVER_PLACEMENT.BOTTOM_RIGHT, POPOVER_PLACEMENT.LEFT_TOP, POPOVER_PLACEMENT.LEFT_BOTTOM, POPOVER_PLACEMENT.RIGHT_TOP, POPOVER_PLACEMENT.RIGHT_BOTTOM]),
  trigger: PropTypes.oneOf([POPOVER_TRIGGER.HOVER, POPOVER_TRIGGER.FOCUS, POPOVER_TRIGGER.CLICK, POPOVER_TRIGGER.CONTEXT_MENU]),
  visible: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  content: PropTypes.node,
  title: PropTypes.node,
  children: PropTypes.node.isRequired,
  autoAdjustOverflow: PropTypes.bool
});
_defineProperty(TPopover, "defaultProps", {
  arrowPointAtCenter: false,
  mouseEnterDelay: undefined,
  mouseLeaveDelay: undefined,
  placement: POPOVER_PLACEMENT.TOP,
  trigger: POPOVER_TRIGGER.CLICK,
  visible: undefined,
  onVisibleChange: _noop,
  content: undefined,
  title: undefined,
  autoAdjustOverflow: true
});
export default TPopover;